import { ChemistryRating } from "./types.js";
const chemistryOptions = (theme) => [
  {
    label: "amazing_chemistry",
    color: theme.palette.success[500],
    tooltipColor: theme.palette.success[50],
    value: ChemistryRating.PLUS
  },
  {
    label: "normal_chemistry",
    value: ChemistryRating.NORMAL
  },
  {
    label: "bad_chemistry",
    color: theme.palette.warning[500],
    tooltipColor: theme.palette.warning[50],
    value: ChemistryRating.MINUS
  },
  {
    label: "blacklist_chemistry",
    color: theme.palette.error[500],
    tooltipColor: theme.palette.error[50],
    value: ChemistryRating.STOP
  }
];
export {
  chemistryOptions
};
